import React from 'react'
import Layout, { Container } from '../components/layout'

const Celebration = () => {
  return (
    <Layout><Container>Celebration</Container></Layout>
  )
}

export default Celebration